<template>
	<div>
		<flEditarVisualizar v-if="exibeStatus" :item="item" :editar="editar" @click-editar="(item) => $emit('click-editar', item)" />

		<div class="row" v-if="_existe(item.descricaoSubstituida)">
			<div class="col-md-12">
				<p style="color: red" v-if="item.descricaoSubstituida != null && item.descricaoSubstituida != ''">SUBSTÍTUIDA - NUMBER: {{item.descricaoSubstituida}}</p>
			</div>
		</div>

		<div class="row">

			<div class="col-md-3">
				<p style="margin-bottom:0px"><small v-if="exibeLegenda" style="color: #777">(Task Number)<br/></small>{{item.taskNumber}} </p>
				<p style=" margin-top:4px"><small v-if="exibeLegenda" style="color: #777;">(Task Title)<br/></small><strong>{{item.taskTitle}}</strong></p>
			</div>

			<div class="col-md-2">
				<small v-if="exibeLegenda && _existe(item.mpnInspecao)" style="color: #777">(MP/N)<br/></small>
				<div v-show="item.mpnInspecao != null && item.mpnInspecao.length > 0 && !it.excluir" v-for="(it, m) in item.mpnInspecao" :key="m">{{it.descricao}}</div>
			</div>

			<div class="col-md-2">
				<small v-if="exibeLegenda && _existe(item.pnInspecao)" style="color: #777">(PN)<br/></small>
				<div v-show="item.pnInspecao != null && item.pnInspecao.length > 0 && !it.excluir" v-for="(it, m) in item.pnInspecao" :key="m">{{it.descricao}}</div>
			</div>

			<div class="col-md-2">
				<small v-if="exibeLegenda" style="color: #777">(limit)<br/></small>
				<!-- <pre>{{item}}</pre> -->
				<div v-for="(inps, idxIns) in item.inspecaoPeriodo" v-show="!inps.excluir" :key="idxIns">
					<span>{{inps.limit}} {{inps.unit}}</span>
					<span style="font-size: 10px; color: #1976D2" v-tooltip.center="'Tolerância'" v-if="inps.margin != 0"> (+{{inps.margin}} {{inps.marginUnit}})</span>
				</div>

			</div>

			<div class="col-md-3">
				<small v-if="exibeLegenda && (_existe(item.ref_manual) || _existe(item.documentation))" style="color: #777">(Documentation)<br/></small>
				<p>{{item.ref_manual}} {{item.documentation}}</p>
			</div>
		</div>

		<div class="row" v-if="_existe(item.description)">
			<div class="col-md-12">
				<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Description)<br/></small>{{item.description}}</p>
			</div>
		</div>

		<div class="row">
			<div class="col-md-3" v-if="_existe(item.c1)">
				<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Mod)<br/></small>{{item.c1}}</p>
			</div>
			<div class="col-md-9" v-if="_existe(item.c2)">
				<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Climatic Condition)<br/></small>{{item.c2}}</p>
			</div>
		</div>

		<!-- <hr style="margin-bottom:0px" /> -->
	</div>
</template>

<script>
import flEditarVisualizar from './editar-visualizar.vue'
export default {

	components: {
		flEditarVisualizar
	},
	props: {
		item: {
			required: true,
			type: Object,
		},

		editar: {
			type: Boolean,
			required: false,
			default: true,
		},

		exibeLegenda: {
			required: true,
			type: Boolean,
		},

		desativar: {
			type: Boolean,
			required: false,
			default: false,
		},

		exibeStatus: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
}
</script>




// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/templates/AIRBUS_MSM_ALS.vue